import { Box, Card, CardContent, Stack } from '@mui/material';
import { Outlet } from 'react-router-dom';

import { BrandMark } from '@/components/common/BrandMark';
import { ROUTES } from '@/constants/routes';

/**
 * The centered card shell for login/register/forgot-password/MFA-challenge screens.
 * Deliberately has no `SideNav`/`TopNav` — pre-authentication screens are their own visual
 * context, and the MFA challenge is a distinct route within this layout, not a modal bolted onto
 * the login form (docs/development/FrontendGuidelines.md §3 identity module notes).
 */
export function AuthLayout() {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'background.default',
        p: 2,
      }}
    >
      <Card sx={{ width: '100%', maxWidth: 420 }}>
        <CardContent sx={{ p: 4 }}>
          <Stack spacing={3}>
            {/* The brand is this screen's `h1` AND its way back out: someone who reached the login
                form from a public page needs a route back to the site that is not the browser's back
                button. The heading sits inside the anchor, which is valid — `<a>` takes flow content —
                and a screen reader announces "WillnQ home, link, heading level 1". */}
            <Box sx={{ display: 'flex', justifyContent: 'center' }}>
              <BrandMark logoSize={48} variant="h5" component="h1" to={ROUTES.root} />
            </Box>
            <Outlet />
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
